// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"LanguageSelectorList_listWrapper__7ctW3"};